import type { AutomationTemplateContents } from '@reach/shared-types/automation-template';
import { BusinessAutomationActionTypeEnum, TimezoneEnum } from '@reach/shared-types/business-automation';

const {
  SEND_COMMUNICATION,
  WAIT_FOR_DURATION,
  WAIT_UNTIL_AT_LEAST_NEXT_AVAILABLE_TIME,
  WAIT_UNTIL_NEXT_OCCURRENCE,
  CHECK_SEGMENT_MEMBERSHIP,
} = BusinessAutomationActionTypeEnum;

export type ActionData = AutomationTemplateContents['actionData'][number];

// Default action data objects (without type, templateActionId, or index)
const sendCommunicationDefaults = {
  html: '',
  css: '',
  compiledHtml: '',
  text: '',
  subject: '',
  previewText: '',
};

const waitForDurationDefaults = {
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
};

const waitUntilDefaults: {
  hour?: number;
  minute?: number;
  timezone: TimezoneEnum;
} = {
  timezone: TimezoneEnum.EST,
};

const checkSegmentMembershipDefaults = {
  segmentIds: [],
};

// Lookup object for action data without type
// Using Partial to allow undefined values for fields that need configuration
export const actionTypeDefaults: Record<
  string,
  Partial<Omit<ActionData, 'type' | 'templateActionId' | 'index'>>
> = {
  [SEND_COMMUNICATION]: sendCommunicationDefaults,
  [WAIT_FOR_DURATION]: waitForDurationDefaults,
  [WAIT_UNTIL_AT_LEAST_NEXT_AVAILABLE_TIME]: waitUntilDefaults,
  [WAIT_UNTIL_NEXT_OCCURRENCE]: waitUntilDefaults,
  [CHECK_SEGMENT_MEMBERSHIP]: checkSegmentMembershipDefaults,
};
